import { fr, nlBE } from 'date-fns/locale';
import { parseISO, format } from 'date-fns';

function capitalizeFirstLetter(string) {
  return string[0].toUpperCase() + string.slice(1);
}

function getLocale(locale) {
  switch (locale) {
    case 'nl':
      return nlBE;
    case 'fr':
      return fr;
    default:
      throw new Error(`Unknown locale "${locale}"`);
  }
}

export function parseDate(dateISO) {
  return parseISO(`${dateISO}T00:00:00Z`);
}

export function formatDate(date, locale) {
  return capitalizeFirstLetter(
    format(date, 'EEEE dd/MM/yyyy', {
      locale: getLocale(locale),
    })
  );
}

export function formatDateShort(date, locale) {
  return capitalizeFirstLetter(
    format(date, 'dd/MM', {
      locale: getLocale(locale),
    })
  );
}

function getTimeSeparator(locale) {
  switch (locale) {
    case 'nl':
      return 'u';
    case 'fr':
      return 'h';
    default:
      throw new Error(`Unknown locale "${locale}"`);
  }
}

export function formatTimeRange(start, end, locale) {
  const timeSeparator = getTimeSeparator(locale);
  return `${start.replace(':', timeSeparator)} - ${end.replace(
    ':',
    timeSeparator
  )}`;
}

export function formatMonth(month, locale) {
  return capitalizeFirstLetter(
    format(month, 'MMMM yyyy', {
      locale: getLocale(locale),
    })
  );
}
